<!-- Removed 360 images -->
@if (ppChange.propName === EActivityPropName.IMAGES_360) {
  <span class="activityChange__icon activityChange__icon--svg">
    <img class="activityChange__icon-svg" [src]="EIconPath.ACTIVITY_IMAGE_360_DARK" />
  </span>
  @if (ppChange.deleted.length === 0) {
    <div class="activityChange">
      {{ 'removed' | ppTranslate }}
      <strong class="timeline__strong">{{ '360_photos' | ppTranslate }}.</strong>
    </div>
  }
  @if (ppChange.deleted.length > 0) {
    <div class="activityChange">
      {{ 'removed' | ppTranslate }}
      <strong class="timeline__strong">{{ ppChange.deleted.length }}</strong>
      {{
      ppChange.deleted.length === 1 ? ('360_photo' | ppTranslate) : ('360_photos' | ppTranslate)
      }}.
    </div>
  }
}

<!-- Removed photos -->
@if (ppChange.propName === EActivityPropName.IMAGES) {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_IMAGE" />
  </span>
  @if (ppChange.deleted.length === 0) {
    <div class="activityChange">
      {{ 'removed' | ppTranslate }}
      <strong class="timeline__strong">{{ 'images' | ppTranslate }}.</strong>
    </div>
  }
  @if (ppChange.deleted.length > 0) {
    <div class="activityChange">
      {{ 'removed' | ppTranslate }}
      <strong class="timeline__strong">{{ ppChange.deleted.length }}</strong>
      {{ ppChange.deleted.length === 1 ? ('image' | ppTranslate) : ('images' | ppTranslate) }}.
      @if (ppChange.deleted.length) {
        <div class="activityChange__media-wrapper">
          @for (value of ppChange.deleted; track value) {
            <span class="activityChange__media-item">
              {{ value.caption }}
              <div>
                @if (value.id) {
                  <img
                    ppImage
                    class="activityChange__uploaded-image activityChange__uploaded-image--deleted"
                    draggable="false"
                    [ppSecureSrc]="'api/v1/images/' + value.id + '/file/size/square/40'"
                    onerror="this.onerror=null;this.src=EIconPath.PLACEHOLDER_IMAGE"
                    />
                }
              </div>
            </span>
          }
        </div>
      }
    </div>
  }
}

<!-- Removed video -->
@if (ppChange.propName === EActivityPropName.VIDEOS) {
  @if (ppChange.deleted.length === 0) {
    <div style="display: flex">
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_VIDEO" />
      </span>
      <div class="activityChange">
        {{ 'removed' | ppTranslate }}
        <strong class="timeline__strong">{{ 'videos' | ppTranslate | lowercase }}.</strong>
      </div>
    </div>
  }
  @if (ppChange.deleted.length > 0) {
    <div style="display: flex">
      <span class="activityChange__icon">
        <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_VIDEO" />
      </span>
      <div class="activityChange">
        {{ 'removed' | ppTranslate }}
        <strong class="timeline__strong">{{ ppChange.deleted.length }}</strong>
        {{
        ppChange.deleted.length === 1
        ? ('video' | ppTranslate | lowercase)
        : ('videos' | ppTranslate | lowercase)
        }}.
      </div>
    </div>
  }
}

<!-- Removed file -->
@if (ppChange.propName === EActivityPropName.DOCUMENTS) {
  <span class="activityChange__icon">
    <img class="activityChange__icon-svg" [src]="EIconPath.BASIC_FIELD_FILE" />
  </span>
  @if (ppChange.removedFiles) {
    @if (!ppChange.removedFiles?.length) {
      <div class="activityChange">
        {{ 'removed' | ppTranslate }}
        <strong class="timeline__strong">{{ 'files' | ppTranslate | lowercase }}.</strong>
      </div>
    }
    @if (ppChange.removedFiles?.length > 0) {
      <div class="activityChange">
        {{ 'removed' | ppTranslate }}
        <strong class="timeline__strong">{{ ppChange.removedFiles.length }}</strong>
        {{
        ppChange.removedFiles.length === 1
        ? ('file' | ppTranslate | lowercase)
        : ('files' | ppTranslate | lowercase)
        }}{{ ppChange.removedFiles[0] ? ':' : '.' }}
        @for (file of ppChange.removedFiles.slice().reverse(); track file; let last = $last) {
          <span
            class="activity__file-name"
            >{{ file }}</span
            >
          }
        </div>
      }
    }
    @if (!ppChange.removedFiles) {
      @if (!ppChange.deleted?.length) {
        <div class="activityChange">
          {{ 'removed' | ppTranslate }}
          <strong class="timeline__strong">{{ 'files' | ppTranslate | lowercase }}.</strong>
        </div>
      }
      @if (ppChange.deleted?.length > 0) {
        <div class="activityChange">
          {{ 'removed' | ppTranslate }}
          <strong class="timeline__strong">{{ ppChange.deleted.length }}</strong>
          {{
          ppChange.deleted.length === 1
          ? ('file' | ppTranslate | lowercase)
          : ('files' | ppTranslate | lowercase)
          }}{{ ppChange.deleted[0].caption ? ':' : '.' }}
          @for (file of ppChange.deleted.slice().reverse(); track file; let last = $last) {
            <span
              class="activity__file-name"
              >{{ file.caption }}</span
              >
            }
          </div>
        }
      }
    }
